var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 28,
    viewBox: "0 0 35 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.736 6.81209C30.7562 7.10431 30.7562 7.39654 30.7562 7.69146C30.7562 16.6777 23.9151 27.0417 11.406 27.0417V27.0363C7.71073 27.0417 4.09224 25.9832 0.981445 23.9874C1.51876 24.0521 2.05878 24.0844 2.60014 24.0857C5.66245 24.0884 8.63723 23.0609 11.0464 21.1689C8.13627 21.1137 5.58434 19.2162 4.69285 16.4461C5.71228 16.6427 6.76268 16.6023 7.76325 16.329C4.59051 15.688 2.30791 12.9004 2.30791 9.66297C2.30791 9.63335 2.30791 9.60507 2.30791 9.57679C3.25327 10.1033 4.31175 10.3956 5.39446 10.4279C2.40622 8.43078 1.4851 4.45542 3.28963 1.34732C6.74248 5.59605 11.8369 8.17895 17.3057 8.45232C16.7576 6.09027 17.5064 3.6151 19.2732 1.95467C22.0123 -0.620156 26.3203 -0.488183 28.8951 2.24959C30.4182 1.94928 31.878 1.39041 33.2139 0.598575C32.7062 2.17283 31.6437 3.51006 30.2243 4.35981C31.5723 4.2009 32.8893 3.84 34.1296 3.28921C33.2166 4.65742 32.0665 5.84922 30.736 6.81209Z",
    fill: "#002561"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterLogo);
export default __webpack_public_path__ + "static/media/TwitterLogo.61d81b6ecb6f8db56024d6447292a9a7.svg";
export { ForwardRef as ReactComponent };